const config = {
    defaultResumePrimaryColor: "#000000",
    defaultResumePrimaryContrastColor: "#FFFFFF",
    defaultResumePdfColor: "#000000",
    defaultImprint: "",
    defaultPrivacy: "",
    bugsnagPublicApiKey: "c4c62a03a8fcf9f7c26f0e55c92d3651",
};

export { config };
